<template>
    <span>
        <span v-if="minutes > 0">{{ minutes }} m.</span>
        <span>{{ seconds }} s.</span>
    </span>
</template>
<script>

    export default {
        name: 'countdown-timer',
        props : {
            order : {
                type: Number,
                default: 59
            }
        },
        data() {
            return {
                time: this.order,
                interval: null
            }
        },
        computed: {
            seconds() {
                return (this.time) % 60;
            },
            minutes() {
                return Math.trunc((this.time) / 60) % 60;
            }
        },
        methods: {
            getResponseTime(){
                return this.order - this.time;
            },
            stopTimer(){
                clearInterval(this.interval);
                this.$emit('timerStop')
            },
            startTimer(){
                this.interval = setInterval(this.incrementTime, 1000);
                this.$emit('timerStart')
            },
            incrementTime() {
                this.time = parseInt(this.time) - 1;
                if(this.time == 0){
                    clearInterval(this.interval);
                    this.time = 0;
                    this.$emit('timerEnd')
                }
            }
        },

        mounted() {
            this.startTimer();
        }

    }
</script>


